import { inject, Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { ErrorService } from '@oca/web-shared';
import { catchError, map, of, switchMap } from 'rxjs';
import { GetAppInfo, GetAppInfoFailure, GetAppInfoSuccess } from './app.actions';
import { selectAppInfo } from './app.selectors';
import { AppService } from './app.service';
import { maybeDispatch } from './initial-state';


@Injectable()
export class AppEffects {
  private actions$ = inject(Actions);
  private router = inject(Router);
  private store = inject(Store);
  private errorService = inject(ErrorService);
  private service = inject(AppService);

  getAppInfo$ = createEffect(() => this.actions$.pipe(
    ofType(GetAppInfo),
    concatLatestFrom(() => this.store.select(selectAppInfo)),
    switchMap(([action, appInfo]) => {
      if (appInfo) {
        return of(GetAppInfoSuccess({ data: appInfo }));
      }
      return this.service.getAppInfo(action.appUrlName).pipe(
        map(data => GetAppInfoSuccess({ data })),
        catchError(err => this.errorService.handleError(action, GetAppInfoFailure, err)),
      );
    }),
  ));

  constructor() {
    this.router.events.subscribe(val => {
      if (val instanceof RoutesRecognized) {
        const appUrlName = val.state.root.firstChild?.params.cityUrlName as string | undefined;
        if (appUrlName) {
          maybeDispatch(this.store, selectAppInfo, item => item?.url_name === appUrlName, GetAppInfo({ appUrlName }));
        }
      }
    });
  }

}
